import { useRef, useState } from 'react'
import { Dialog, Pane, toaster } from 'evergreen-ui'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5'
import { AiOutlineUpload } from 'react-icons/ai'
import '../styles/components/button.scss'
import '../styles/components/dialog.scss'

const VerifyUserAccountDialog = ({ isShown, setIsShown, onSendClick }) => {
    const inputFile = useRef()

    const handleDialogClose = () => {
        setIsShown(false)
    }
    const handleVerifyClick = () => {
        setIsShown(false)
        onSendClick()
    }

    const customDialogFooter = () => {
        return (
            <div className="dialogCustomFooter">
                <button type="button" className="cancelButton" onClick={handleDialogClose}>
                    Anuluj
                </button>
                <button type="button" className="button" onClick={handleVerifyClick}>
                    Zatwierdź
                </button>
            </div>
        )
    }

    return (
        <Dialog
            isShown={isShown}
            title="Weryfikacja"
            onCloseComplete={handleDialogClose}
            confirmLabel="Wybierz plik"
            onConfirm={() => inputFile.current.click()}
            cancelLabel="Anuluj"
            width={700}
            contentContainerProps={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            topOffset={60}
            footer={customDialogFooter}
        >
            <p>Czy na pewno chcesz zatwierdzić dane przesłane przez odbiorcę?</p>
        </Dialog>
    )
}

export default VerifyUserAccountDialog
